




import Vue from "vue";
import Component from "vue-class-component";
import BasicComponent from "@/global/BasicComponent";
import ImageDownload from "@/components/ImageDownload.vue";

@Component({
  components: {ImageDownload}
})
export default class Home extends BasicComponent {

  get code() {
    return this.$route.params["code"];
  }
}
